import React, { useState, useEffect } from "react";
import TimeSpentCard from "../components/reports/TimeSpendCard";
import ActivityConsistencyCard from "../components/reports/ActivityConsistencyCard";
import YearOverviewCard from "../components/reports/YearOverViewCard";
import MasterySummaryCard from "../components/reports/MasterySummaryCard";
import CourseSubjectAnalysisCard from "../components/dashboard/CourseSubjectAnalysisCard";

const Reports = ({ data }) => {
  const [reportData, setReportData] = useState(data || []);
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    if (data) {
      setReportData(data);
      setLoading(false);
      return;
    }
  }, [data]);

  if (!reportData) {
    return null;
  }

  return (
    <div className=" reports-container">
      <div className="reports-grid time-spent-activity-grid">
        {reportData?.showAnalysisCard !== false && (
          <CourseSubjectAnalysisCard
            subjects={reportData?.course_subject_analysis_array || []}
          />
        )}
        <TimeSpentCard overallTimeSpent={reportData.overall_time_spent || []} />
      </div>
      <div className="reports-grid reports-grid--full">
        <div className="reports-grid__row reports-grid__row--mastery reports-grid__row--two-col">
          <MasterySummaryCard
            title="Active Recall Mastery Overview"
            primaryLabel="Active recall"
            mastery={reportData.active_recall_mastery || {}}
            subjectCategory={reportData.subject_category || []}
            chartType="stack"
            mode="active_recall"
          />
          <MasterySummaryCard
            title="Adaptive learning Mastery Overview"
            primaryLabel="Adaptive learning"
            mastery={reportData.adaptive_learning_mastery || {}}
            subjectCategory={reportData.subject_category || []}
            chartType="pie"
            mode="adaptive_learning"
          />
        </div>

        <div className="reports-grid__row reports-grid__row--mastery reports-grid__row--two-col">
          <MasterySummaryCard
            title="Quiz Mastery Overview"
            primaryLabel="Quiz"
            mastery={reportData.quiz_completed_mastery || {}}
            subjectCategory={reportData.subject_category || []}
            chartType="doughnut"
            mode="quiz"
          />
          <MasterySummaryCard
            title="Test Mastery Overview"
            primaryLabel="Tests"
            mastery={reportData.test_completed_mastery || {}}
            subjectCategory={reportData.subject_category || []}
            chartType="bar"
            mode="test"
          />
        </div>

        {/* <div className="reports-grid__row reports-grid__row--mastery">
          <MasterySummaryCard
            title="Question Bank Mastery Overview"
            primaryLabel="Question Banks"
            mastery={reportData.question_bank_mastery || {}}
            subjectCategory={reportData.subject_category || []}
            chartType="polar"
          />
        </div> */}
      </div>
      <div className="reports-grid reports-grid--full">
        <div className="reports-grid__row">
          <YearOverviewCard yearTimeSpent={reportData.year_time_spent || []} />
        </div>
      </div>
    </div>
  );
};

export default Reports;
